(function () {
  'use strict';

  var NAV = '[data-section-type="header"] .site-navigation';

  function bouwMenuOm() {
    var items = document.querySelectorAll(NAV + ' details[data-hover="true"]');

    Array.prototype.forEach.call(items, function (oud) {
      var nieuw = oud.cloneNode(true);
      oud.parentNode.replaceChild(nieuw, oud);
      nieuw.removeAttribute('open');
      nieuw.removeAttribute('data-hover');

      Array.prototype.forEach.call(
        nieuw.querySelectorAll('.site-nav__dropdown-link--top-level'),
        function (link) {
          var span = document.createElement('span');
          span.className = link.className;
          span.innerHTML = link.innerHTML;
          link.parentNode.replaceChild(span, link);
        }
      );

      var summary = nieuw.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var open = nieuw.hasAttribute('open');
        sluitAlles();
        if (!open) {
          nieuw.setAttribute('open', '');
          nieuw.setAttribute('aria-expanded', 'true');
          summary.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function sluitAlles() {
    Array.prototype.forEach.call(
      document.querySelectorAll(NAV + ' details.site-nav__details'),
      function (d) {
        d.removeAttribute('open');
        d.setAttribute('aria-expanded', 'false');
        var s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      }
    );
  }

  function start() {
    bouwMenuOm();

    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest(NAV)) sluitAlles();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') sluitAlles();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', bouwMenuOm);
})();
